import { render } from "./CentralDashboardHeader.vue?vue&type=template&id=09851e34&ts=true"
import script from "./CentralDashboardHeader?vue&type=script&lang=ts&external"
export * from "./CentralDashboardHeader?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__